module.exports = __webpack_public_path__ + "img/ring_r_i_1_null@3x.44f5c08f.png";